module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "auditreview"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "header-tips",
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 16,
      "lg": 10
    }
  }, [(_vm.newContent.mediaurl) ? _c('audio', {
    staticClass: "header-tips-audio",
    attrs: {
      "src": _vm.newContent.mediaurl,
      "controls": "controls",
      "controlsList": "nodownload",
      "oncontextmenu": "return false"
    }
  }, [_vm._v("\n      您的浏览器不支持 audio 标签。\n      ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 4
    }
  }, [_c('span', {
    staticClass: "header-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.newContent.done
    },
    on: {
      "click": function($event) {
        _vm.handleAuditFormEdit(_vm.newContent)
      }
    }
  }, [_vm._v("驳回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.newContent.done
    },
    on: {
      "click": function($event) {
        _vm.releaseNews(_vm.newContent.id)
      }
    }
  }, [_vm._v("通过")])], 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "editor-content"
  }, [_c('div', {
    staticClass: "news-box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('span', {
    staticClass: "new-type fs-label"
  }, [_vm._v(_vm._s(_vm.formatCategory))]), _vm._v(" "), _c('span', {
    staticClass: "hot-level fs-label"
  }, [_vm._v(_vm._s(_vm.formatHotIndex))])]), _vm._v(" "), _c('div', {
    staticClass: "box-title"
  }, [_c('h1', {
    staticClass: "fs-title"
  }, [_vm._v(_vm._s(_vm.newContent.title))])]), _vm._v(" "), _c('div', {
    staticClass: "box-author fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.newContent.date) + " ")]), _vm._v(" "), (_vm.newContent.editorname) ? _c('span', [_vm._v(" 编:" + _vm._s(_vm.newContent.editorname))]) : _vm._e(), _vm._v(" "), (_vm.newContent.hostname) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.hostname))]) : (_vm.newContent.host) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.host))]) : _vm._e(), _vm._v(" "), (_vm.newContent.verifiername) ? _c('span', [_vm._v(" 审:" + _vm._s(_vm.newContent.verifiername))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 20,
      "sm": 20,
      "md": 12,
      "lg": 10
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newContent.cover),
      expression: "newContent.cover"
    }],
    staticClass: "box-image",
    attrs: {
      "src": _vm.newContent.cover
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('p', {
    staticClass: "box-text fs-text"
  }, [_vm._v(_vm._s(_vm.newContent.content))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-source fs-text"
  }, [_c('span', [_vm._v("新闻来源:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatSourcefrom))])]), _vm._v(" "), _c('div', {
    staticClass: "box-origin fs-text"
  }, [_c('span', [_vm._v("原文地址:")]), _c('a', {
    attrs: {
      "href": _vm.newContent.sourceurl,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "link-url"
  }, [_vm._v(_vm._s(_vm.newContent.sourceurl))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-foot fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.formatLabels2))])]), _vm._v(" "), _c('el-row', {
    staticClass: "pre-next-page",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', [(_vm.preNewsId !== -1) ? _c('router-link', {
    attrs: {
      "to": {
        path: _vm.urladdr,
        query: {
          id: _vm.newsdata[_vm.preNewsId].id,
          index: _vm.preNewsId
        }
      }
    }
  }, [_c('p', {
    staticClass: "page-text fs-label"
  }, [_vm._v("上一篇 " + _vm._s(_vm.newsdata[_vm.preNewsId].title))])]) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', [(_vm.nextNewsId !== -1) ? _c('router-link', {
    attrs: {
      "to": {
        path: _vm.urladdr,
        query: {
          id: _vm.newsdata[_vm.nextNewsId].id,
          index: _vm.nextNewsId
        }
      }
    }
  }, [_c('p', {
    staticClass: "page-text fs-label"
  }, [_vm._v("下一篇 " + _vm._s(_vm.newsdata[_vm.nextNewsId].title))])]) : _vm._e()], 1)])], 1)], 1)])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.auditFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.auditFormVisible),
      callback: function($$v) {
        _vm.auditFormVisible = $$v
      },
      expression: "auditFormVisible"
    }
  }, [_c('el-form', {
    ref: "auditForm",
    attrs: {
      "model": _vm.auditForm,
      "rules": _vm.auditFormRules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "移动至",
      "prop": "state"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.auditForm.state),
      callback: function($$v) {
        _vm.$set(_vm.auditForm, "state", $$v)
      },
      expression: "auditForm.state"
    }
  }, _vm._l((_vm.formatAuditType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原因",
      "prop": "tip"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 60
      },
      "placeholder": "请输入驳回理由，最少5个字，最多60个字。"
    },
    model: {
      value: (_vm.auditForm.tip),
      callback: function($$v) {
        _vm.$set(_vm.auditForm, "tip", $$v)
      },
      expression: "auditForm.tip"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.auditFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editSubmit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.auditFormBtn))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5ba17e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audit/review.vue
// module id = 776
// module chunks = 6